import React, { Component } from 'react'
import styled from 'styled-components'

class PrimaryButton extends Component {
  constructor() {
    super()
    this.state = {
      hovered: false,
    }
  }

  render() {
    return (
      <Container className={this.props.className} style={this.props.style}>
        <InnerButton
          onClick={this.props.onClick}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}>
          {this.props.text}
        </InnerButton>
        <Overlay />
        <Shadow hover={this.state.hovered} />
      </Container>
    )
  }
}

const Container = styled.div`
  position: relative;
`

const Overlay = styled.div`
  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
`

const InnerButton = styled.button`
  text-transform: uppercase;
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  box-sizing: border-box;
  padding: 17px;
  width: 100%;
  transition: all 0.1s ease-in-out;
  height: 48px;
  font-family: 'Nunito';
  color: #fff;
  position: relative;
  z-index: 2;

  &:disabled {
    background: none;
    background-color: #ddd;
    cursor: default;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`

const Shadow = styled.div`
  position: absolute;
  width: 75%;
  height: 8px;
  top: 40px;
  box-shadow: 0 2px 15px 0
    rgba(0, 0, 0, ${({ hover }) => (hover ? '0.5' : '0.3')});
  left: 12.5%;
  transition: all 0.2s ease;
`

export default PrimaryButton



// WEBPACK FOOTER //
// ./src/components/PrimaryButton/index.js